// extracted by mini-css-extract-plugin
export default {"MyAccount":"MyAccount_MyAccount","contentContainer":"MyAccount_contentContainer","content":"MyAccount_content","headline":"MyAccount_headline"};